import axios from 'axios';
import { protectedAxiosInstance } from 'helpers/api-calls';
import { isValidObject } from '../validation';

export const AddDraftShiftToUserCall = (userId, startDateTime, endDateTime, jobTitle, locationId, roleIds) => {
    const payload = {
      "schedule_element": {
        "start_at": startDateTime,
        "end_at": endDateTime,
        "cached_primary_job": jobTitle,
        "name": "shift_inventory",
        "owner_id": userId,
        "non_filter_tag_ids": roleIds,
      }
    };
  
    return protectedAxiosInstance.request({
      url: `api/customer/user_role/locations/${locationId}/schedule_elements/draft_create`,
      method: 'POST',
      data: payload
    });
};

export const AddDraftOpenShiftToUserCall = (userId, startDateTime, endDateTime, jobTitle, locationId, channelId, shiftDescription, quantity, roleIds, skillIds) => {
   return AddBulkDraftToUserCall('open_shift', userId, startDateTime, endDateTime, jobTitle, locationId, channelId, shiftDescription, quantity, roleIds, skillIds);
};

export const AddDraftVTOToUserCall = (userId, startDateTime, endDateTime, jobTitle, locationId, channelId, shiftDescription, quantity, roleIds, skillIds) => {
  return AddBulkDraftToUserCall('shift_vto', userId, startDateTime, endDateTime, jobTitle, locationId, channelId, shiftDescription, quantity, roleIds, skillIds);
};

const AddBulkDraftToUserCall = (shiftType, userId, startDateTime, endDateTime, jobTitle, locationId, channelId, shiftDescription, quantity, roleIds, skillIds) => {
  const payload = {
    "schedule_element": {
      "start_at": startDateTime,
      "end_at": endDateTime,
      "cached_primary_job": jobTitle,
      "name": shiftType,
      "channel_id": channelId,
      "total_shifts_available": quantity,
      "shift_content": shiftDescription,
      "owner_id": userId, 
      "non_filter_tag_ids": roleIds,
      "skill_ids": skillIds,
    }
  };

  return protectedAxiosInstance.request({
    url: `api/customer/user_role/locations/${locationId}/schedule_elements/draft_create`,
    method: 'POST',
    data: payload
  });
};  

  export const DeleteDraftShiftCall = (scheduleId, locationId) => {
    return protectedAxiosInstance.request({
      url: `/api/customer/user_role/locations/${locationId}/schedule_elements/${scheduleId}`,
      method: 'DELETE'
    });
  };
  
  export const AddDraftShiftToUnregisteredUserCall = (unregUserId, startDateTime, endDateTime, jobTitle, locationId, roleIds) => {
    const payload = {
      "schedule_element": {
        "start_at": startDateTime,
        "end_at": endDateTime,
        "cached_primary_job": jobTitle,
        "name": "shift_inventory",
        "unregistered_user_id": unregUserId,
        "non_filter_tag_ids": roleIds,
      }
    };
  
    return protectedAxiosInstance.request({
      url: `api/customer/user_role/locations/${locationId}/schedule_elements/draft_create`,
      method: 'POST',
      data: payload
    });
  };

  export const PublishDraftShiftCall = (draftShiftId) => {
    return protectedAxiosInstance.request({
      url: `api/customer/user_role/schedule_elements/${draftShiftId}/publish`,
      method: 'PUT',
    });
  }

  export const UpdateDraftShiftCall = (draftShiftId, targetRegisteredUserId, targetUnregisteredUserId, targetStartTime, targetEndTime, jobTitle, roleIds, skillIds) => {
    var json = {};

    if( targetRegisteredUserId !== null){
      json.owner_id = targetRegisteredUserId;
    }

    if( targetUnregisteredUserId !== null){
      json.unregistered_user_id = targetUnregisteredUserId;
    }

    if( targetStartTime !== null ){
      json.start_at = targetStartTime;
    }

    if( targetEndTime !== null ) {
      json.end_at = targetEndTime;
    }

    if( jobTitle !== null ){
      json.cached_primary_job = jobTitle;
    }

    if( roleIds !== null && isValidObject(roleIds) && roleIds.length > 0 ){
      json.non_filter_tag_ids = roleIds;
    }

    if( skillIds !== null && isValidObject(skillIds) && skillIds.length > 0 ){
      json.skill_ids = skillIds;
    }

    console.log(JSON.stringify(json));

    const payload = {
      "schedule_element": json 
    };

    return protectedAxiosInstance.request({
      url: `api/customer/user_role/schedule_elements/${draftShiftId}/draft_update`,
      method: 'PUT',
      data: payload
    }); 
  }

  export const RevertAllDraftChangesCall = () => {
    return protectedAxiosInstance.request({
      url: `api/customer/`,
      method: 'POST',
      data: payload
    });
  }

export default {
};
